import React, { Component } from 'react';
import styled from 'styled-components'
import { Button, Select, Card, Divider, Input, Form } from 'antd'
import { apiUtil as Util } from '../../mock/mockServices';

const { Option } = Select

let params = new URLSearchParams(window.location.search);
let roleId = params.get('id');

const formItemLayout = {
    labelCol: {
        span: 4
    },
    wrapperCol: {
        span: 20
    }
};

class RoleMgrComponent extends Component {

    state = {
        id: roleId,
        orgId: '',
        rName: '',
        rDesc: '',
        rStatus: '',
        orgList: [],
        privilegeList: [],
    }

    componentDidMount() {
        if (roleId !== "0" && roleId !== null && roleId !== "null") {
            Util.ajax.get('/admin/getOrgInfoById', {
                id: roleId
            }).then(res => {
                const { data } = res
                if (!data) {
                    return false
                }
                const { orgId, rName, rDesc, rStatus } = data

                this.setState({
                    id: roleId,
                    orgId: orgId ? orgId.value : '',
                    rName: rName ? rName.value : '',
                    rDesc: rDesc ? rDesc.value : '',
                    rStatus: rStatus ? rStatus.value : '',
                })
            })
        }

        
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, value) => {
            if (!err) {
                console.log('Received values of form: ', value);
                if (roleId !== "0"){
                    Util.ajax.post('/admin/createRole', value).then(res => {
                        Util.message.success('Saved successfully')
                    })
                } else {
                    Util.ajax.post('/admin/editRole', value).then(res => {
                        Util.message.success('Saved successfully')
                    })
                }
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout="horizontal" {...formItemLayout} style={{ width: '660px' }} onSubmit={this.handleOk}>
                <Form.Item label="Organization ID">
                    {getFieldDecorator('orgId', {
                        initialValue: '1'
                    })(<Select>
                        {this.state.orgList.map(org =>
                            <Option key={org.id} value={org.id.toString()}>{org.name}</Option>
                        )}
                    </Select>)}
                </Form.Item>
                <Form.Item label="Role Name">
                    {getFieldDecorator('rName', {
                        initialValue: this.state.rName,
                        rules: [
                            { required: true, message: 'Please enter the role name', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="Role Description">
                    {getFieldDecorator('rDesc', {
                        initialValue: this.state.rDesc,
                        rules: [
                            { required: true, message: 'Please enter the role description', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="Role Status">
                    {getFieldDecorator('rStatus', {
                        initialValue: this.state.rStatus,
                        rules: [
                            { required: true, message: 'Please enter the role status', whitespace: true },
                        ]
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="" wrapperCol={{ push: 4 }}>
                    <Button className="mr20" onClick={this.handleTest}>Clear</Button>
                    <Button type="primary" onClick={this.handleSubmit}>Save</Button>
                </Form.Item>
            </Form>
        )
    }
}

const RoleMgrForm = Form.create({ name: 'role-mgr-form' })(RoleMgrComponent)

export default class RoleMgr extends Component {

    render() {
        const isNew = roleId === "0";
        return (
            <Root>
                <div className="page-content">
                    <Card title={
                        <div style={{ fontSize: '22px', fontWeight: 'bold' }}>Role Management</div>
                    } bordered={false} style={{ width: '100%' }}>
                        {/* <div className="title"></div>
                        <Divider></Divider> */}
                        <div className="sub-title">
                            {isNew ? (
                                <div>Add Role</div>
                            ) : (
                                <div>Edit Role (id: {roleId})</div>
                            )}
                        </div>
                        <Divider></Divider>
                        <RoleMgrForm></RoleMgrForm>
                    </Card>
                </div>
            </Root>

        )
    }
}

const Root = styled.div`
    .title{
        font-size: 22px;
        font-weight: bold;
    }
    .sub-title{
        font-size:18px;
        font-weight: bold;
        padding: 5px 0 15px;
    }
`